<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="广告名称">
                  <el-input style="width: 177px" v-model="queryForm.adsName"></el-input>
              </el-form-item>
              <el-form-item label="链接类型">
<!--                  <el-input  v-model="queryForm.linkType"></el-input>-->
                  <el-select placeholder="请选择状态" clearable style="width: 177px"
                             size="small" v-model="queryForm.linkType">
                      <el-option v-for='(item, index) in adsLinkList' :key='index' :label="item.value" :value="item.key"></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="广告链接">
                  <el-input style="width: 177px" v-model="queryForm.adsLink"></el-input>
              </el-form-item>
              <el-form-item label="分类">
<!--                  <el-input  v-model="queryForm.categoryId"></el-input>-->
                  <el-select
                      style="width: 177px"
                      v-model="queryForm.categoryId"
                      placeholder="请选择分类名称"
                      clearable
                      size="small"
                  >
                      <el-tree default-expand-all :data="mppFileFolderList" :props="{ children: 'children', label: 'folderName' }">
                          <div class="custom-tree-node flex items-center" slot-scope="{ node, data }">
                              <el-option :label="data.categoryName" :value="data.id"> </el-option>
                          </div>
                      </el-tree>
                  </el-select>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getCmsAdsList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addCmsAds"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editCmsAds(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteCmsAds(null)"
        >删除</el-button>
          <el-button
              type="primary"
              size="small"
              @click="openIsShow"
          >广告分类管理</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshCmsAdsList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="cmsAdsList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="adsName"
        label="广告名称"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="adsPic"
        label="广告图片"
        width="180"
      > 
        <template slot-scope="scope">
            <div v-if='scope.row.adsPic'>
              <el-image @click='updateSrcList(scope.row.adsPic)' style="width: 60px; height: 60px"
                :src="scope.row.adsPic" :preview-src-list="srcList"> </el-image>
            </div>
            <div v-else>--</div>
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="linkType"
        label="链接类型"
        width="180"
      >
        <template slot-scope="scope">
          {{ getadslinks(scope.row.linkType) }}
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="adsLink"
        label="广告链接"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="categoryId"
        label="分类"
        width="180"
      >
        <template slot-scope="scope">
          {{ getcmsCategorys(scope.row.categoryId) }}
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="isShow"
        label="是否显示"
        width="180"
      >
        <template slot-scope="scope">
          {{ adsyesno(scope.row.isShow) }}
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="sort"
        label="排序"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkCmsAds(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editCmsAds(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteCmsAds(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="cmsAdsStates[cmsAdsState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="cmsAds"
          ref="cmsAdsForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="广告名称"
            prop="adsName"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="cmsAds.adsName"
              :disabled="cmsAdsState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="链接类型"
            prop="linkType"
          >
            <!-- <el-input
              size="small"
              style="width: 200px"
              v-model="cmsAds.linkType"
              :disabled="cmsAdsState == 'check'"
            ></el-input> -->
            <el-select placeholder="请选择状态" :disabled="cmsAdsState == 'check'" clearable style="width: 200px"
                size="small" v-model="cmsAds.linkType">
                <el-option v-for='(item, index) in adsLinkList' :key='index' :label="item.value" :value="item.key"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="广告链接"
            prop="adsLink"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="cmsAds.adsLink"
              :disabled="cmsAdsState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="分类"
            prop="categoryId"
          >
          <el-select
              style="width: 200px"
              v-model="cmsAds.categoryId"
              placeholder="请选择分类名称"
              :disabled="cmsAdsState == 'check'"
              clearable
              size="small"
          >
              <el-tree default-expand-all :data="mppFileFolderList" :props="{ children: 'children', label: 'folderName' }">
                  <div class="custom-tree-node flex items-center" slot-scope="{ node, data }">
                      <el-option :label="data.categoryName" :value="data.id"> </el-option>
                  </div>
              </el-tree>
          </el-select>
          </el-form-item>
          <el-form-item
            label="是否显示"
            prop="isShow"
          >
            <!-- <el-input
              size="small"
              v-model="cmsAds.isShow"
              :disabled="cmsAdsState == 'check'"
            ></el-input> -->
            <el-select placeholder="请选择状态" :disabled="cmsAdsState == 'check'" clearable style="width: 200px"
                size="small" v-model="cmsAds.isShow">
                <el-option v-for='(item, index) in yesNoList' :key='index' :label="item.value" :value="item.key"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="排序"
            prop="sort"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="cmsAds.sort"
              :disabled="cmsAdsState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="广告图片"
            prop="adsPic"
          >
            <!-- <el-input
              size="small"
              style="width: 200px"
              v-model="cmsAds.adsPic"
              :disabled="cmsAdsState == 'check'"
            ></el-input> -->
            <el-upload :action="action" :headers="header" :before-upload="beforeImageUpload"
              :disabled="cmsAdsState == 'check'" class="avatar-uploader" :show-file-list="false"
              :http-request="uploadImage">
              <img v-if="cmsAds.adsPic" :src="cmsAds.adsPic" class="avatar" size="small" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="cmsAdsState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
      <el-drawer
          title="广告分类管理"
          :visible.sync="isShow"
          direction="rtl"
          size="70%"
          :before-close="closeIsShow">
          <CmsAdsCategory ref='cmsAdsCategory'></CmsAdsCategory>
      </el-drawer>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun, upload } from '@/utils/request.js';
import { UPLOAD_PATH, UPLOAD_API, USER, PRODUCT, PRODUCT_SEARCH, USER_SEARCH } from '@/utils/constant.js';
import CmsAdsCategory from '@/components/cms/CmsAdsCategory.vue';
export default {
    components: {
        Edit24Regular,
        CmsAdsCategory,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetCmsAdsList();
                    this.getCmsAdsList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetCmsAdsList();
                    this.getCmsAdsList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     adsName: '', //广告名称
                     adsPic: '', //广告图片
                     linkType: '', //链接类型
                     adsLink: '', //广告链接
                     categoryId: '', //分类ID
                     isShow: '', //是否显示
                     sort: '', //排序
                     createTime: '', //
                },
                header: {
                  token: localStorage.getItem('token')
                },
                action: UPLOAD_API + UPLOAD_PATH,
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                cmsAdsState: 'add',
                cmsAdsStates: {
                    add: '新建广告',
                    check: '查看广告',
                    edit: '修改广告'
                },
                adsLinkList: [],
                yesNoList: [],
                multipleSelection: [],
                cmsAdsList: [],
                cmsAds: {
                    adsName: '', //广告名称
                    adsPic: '', //广告图片
                    linkType: '', //链接类型
                    adsLink: '', //广告链接
                    categoryId: '', //分类ID
                    isShow: '', //是否显示
                    sort: '', //排序
                    createTime: '', //
                },
                btnLoading: false,

                rules: {
                    adsName: [{ required: true, message: '广告名称不能为空', trigger: 'blur' }],
                    adsPic: [{ required: true, message: '广告图片不能为空', trigger: 'blur' }],
                    linkType: [{ required: true, message: '链接类型不能为空', trigger: 'blur' }],
                    adsLink: [{ required: true, message: '广告链接不能为空', trigger: 'blur' }],
                    categoryId: [{ required: true, message: '分类ID不能为空', trigger: 'blur' }],
                    isShow: [{ required: true, message: '是否显示不能为空', trigger: 'blur' }],
                    sort: [{ required: true, message: '排序不能为空', trigger: 'blur' }],
                },
                srcList:[''],
                getEumnList: [],
                mppFileFolderList:[],

                isShow: false
            };
        },
        created() {
            this.getCmsAdsList();
            this.getCmsAdsLists();
            this.getEumnLists();
            this.getMppFileFolderList()
        },
        methods: {
            beforeImageUpload(file) {
              const isLt2M = file.size / 1024 / 1024 < 50;
              if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 50MB!');
              }
              return isLt2M;
            },
            uploadImage(params) {
              const file = params.file;
              let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
              if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
              }
              const formData = new FormData();
              formData.append('file', file);
              upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                  this.cmsAds.adsPic = res.url;
                }
              });
            },
            openIsShow(){
                this.isShow = true
                this.$nextTick(()=>{
                    this.$refs.cmsAdsCategory.init()
                })
            },
            closeIsShow(){
                this.isShow = false
                this.refreshCmsAdsList()
                this.getEumnLists()
                this.getMppFileFolderList()
            },
            getMppFileFolderList() {
              get(`cms/adscategory/findAllAsTree`).then((res) => {
                this.loading = false;
                if (res.success) {
                  this.mppFileFolderList = res.treeData;
                  console.log(this.mppFileFolderList);
                  // this.totalNum = res.page.total;
                } else {
                  this.$message({
                    message: res.msg,
                    type: 'error',
                    duration: 2000
                  });
                }
              });
            },
            // 分类
            getEumnLists(){
              get(`/cms/adscategory/findAll`).then((res) => {
                    if (res.success) {
                        console.log(res)
                        this.getEumnList = res.list;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getcmsCategorys(key){
              for (const iterator of this.getEumnList) {
                if(iterator.id == key){
                  return iterator.categoryName
                }
              }
            },
            getCmsAdsLists() {
              // 链接类型
              get('/mpp/utils/getEnum', {
                enumType: 'ads_link_type',
              }).then((res) => {
                if (res.success) {
                  // console.log(res.enumList)
                  this.adsLinkList = res.enumList
                }
              })
              // 是否显示
              get('/mpp/utils/getEnum', {
                enumType: 'yes_no',
              }).then((res) => {
                if (res.success) {
                  // console.log(res.enumList)
                  this.yesNoList = res.enumList
                }
              })
            },
            // 链接类型
            getadslinks(key){
              for (const iterator of this.adsLinkList) {
                if(iterator.key == key){
                  return iterator.value
                }
              }
            },
            // 是否显示
            adsyesno(key){
              for (const iterator of this.yesNoList) {
                if(iterator.key == key){
                  return iterator.value
                }
              }
            },
            // 大图预览
            updateSrcList(src) {
              this.srcList[0] = src
            },
            search(){
                this.isSearch = !this.isSearch;
            },
            resetCmsAdsList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.cmsAdsList = [];
            },
            resetDialog() {
                this.cmsAdsState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      adsName: '', //广告名称
                      adsPic: '', //广告图片
                      linkType: '', //链接类型
                      adsLink: '', //广告链接
                      categoryId: '', //分类ID
                      isShow: '', //是否显示
                      sort: '', //排序
                      createTime: '', //
                };
                this.getCmsAdsList();
            },
            closeDialog() {
                this.showDialog = false
                this.cmsAds = {
                      adsName: '', //广告名称
                      adsPic: '', //广告图片
                      linkType: '', //链接类型
                      adsLink: '', //广告链接
                      categoryId: '', //分类ID
                      isShow: '', //是否显示
                      sort: '', //排序
                      createTime: '', //
                };
            },
            submitForm() {
                if (this.cmsAdsState == 'add') {
                    this.$refs.cmsAdsForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/cms/ads/add`,{ ...this.cmsAds }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetCmsAdsList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.cmsAdsState == 'edit') {
                    this.$refs.cmsAdsForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/cms/ads/edit`,{ ...this.cmsAds }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetCmsAdsList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addCmsAds() {
                this.showDialog = true;
                this.cmsAdsState = 'add';
            },
            checkCmsAds(cmsAdsId) {
                console.log(cmsAdsId);
                this.currentCmsAdsId = cmsAdsId;

                this.getCmsAdsById();
                this.showDialog = true;
                this.cmsAdsState = 'check';
            },
            editCmsAds(cmsAdsId) {
                console.log('cmsAds', cmsAdsId);
                if (cmsAdsId) {
                    this.currentCmsAdsId = cmsAdsId;
                    this.getCmsAdsById();
                } else {
                    this.cmsAds = { ...this.cmsAds, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.cmsAdsState = 'edit';
            },
            deleteCmsAds(cmsAdsId) {
                let ids = '';
                if (cmsAdsId) {
                    ids = cmsAdsId;
                } else {
                    ids = this.multipleSelection.map((cmsAds) => cmsAds.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/cms/ads/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetCmsAdsList();
                                this.getCmsAdsList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshCmsAdsList() {
                this.resetCmsAdsList();
                this.getCmsAdsList();
            },
            getCmsAdsList(query = {}) {
                this.loading = true;
                get(`/cms/ads/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.cmsAdsList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getCmsAdsById() {
                get(`/cms/ads/get`,{ id: this.currentCmsAdsId }).then((res) =>{
                    if(res.success){
                      this.cmsAds = { ...this.cmsAds, ...res.cmsAds };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportCmsAdsList() {
                //this.btnLoading = true;
                exprotExcel(`/cms/ads/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/cms/ads/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/cms/ads/importData`,formData);
              this.refreshCmsAdsList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getCmsAdsList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getCmsAdsList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.avatar {
  width: 200px;
  height: 200px;
  display: block;
}

::v-deep .el-upload--text {
  width: 200px;
  height: 200px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 200px;
  height: 200px;
  line-height: 200px;
  text-align: center;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>